import removeNotNumberFromString from './removeNotNumberFromString';

/**
 * 휴대폰번호 중 앞자리를 제외한 짧은 번호 형식 지정 함수입니다.
 * 변환 형식 : '000-0000' 또는 '0000-0000'
 * @param {string} sourceString
 * @returns {string} 숫자외 다른 문자를 제거하고 변환 형식으로 문자열 형식을 조정합니다.
 */
export default function getFormattedShortPhoneNumber(sourceString) {
  let regPhoneNum = '';
  let dataForm = '';
  let formattedPhoneNumber = sourceString;

  // return blank
  if (!sourceString) {
    return '';
  }

  // delete not number
  formattedPhoneNumber = removeNotNumberFromString(formattedPhoneNumber);

  /* 5자리 미만일 경우 위에서 숫자 외 다른문자 제거한 상태로 리턴. */
  if (formattedPhoneNumber.length < 5) {
    return formattedPhoneNumber;
  }

  // 8자리가 넘어가는 숫자는 제거한다.
  if (formattedPhoneNumber.length > 8) {
    formattedPhoneNumber = formattedPhoneNumber.substring(0, 8);
  }

  if (formattedPhoneNumber.length < 8) {
    dataForm = '$1-$2';
    regPhoneNum = /([0-9]{3})([0-9]{4})/;
  } else if (formattedPhoneNumber.length === 8) {
    dataForm = '$1-$2';
    regPhoneNum = /([0-9]{4})([0-9]{4})/;
  }

  return formattedPhoneNumber.replace(regPhoneNum, dataForm);
}
